export default __webpack_public_path__ + "static/media/digital_bjt.9421d10b.svg";